import React from 'react';
import { Trash2 } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Button } from '@/components/ui/button';
import { CourseForm, LessonList, LoadingState } from './';
import { CourseFormValues } from './CourseForm';
import { LessonData } from '@/hooks/useCourseEditor';

interface CourseEditorContentProps {
  isLoading: boolean;
  isNewCourse: boolean;
  courseId: string;
  lessons: LessonData[];
  setLessons: React.Dispatch<React.SetStateAction<LessonData[]>>;
  initialFormValues: CourseFormValues;
  isSaving: boolean;
  onSubmit: (values: CourseFormValues) => Promise<void>;
  onDelete?: () => Promise<void>;
}

const CourseEditorContent: React.FC<CourseEditorContentProps> = ({
  isLoading,
  isNewCourse,
  courseId,
  lessons,
  setLessons,
  initialFormValues,
  isSaving,
  onSubmit,
  onDelete
}) => {
  if (isLoading) {
    return <LoadingState />;
  }

  return (
    <div className="space-y-6">
      {!isNewCourse && onDelete && (
        <div className="flex justify-end">
          <Button
            variant="destructive"
            size="sm"
            onClick={onDelete}
            disabled={isSaving}
            className="flex items-center gap-1"
          >
            <Trash2 className="h-4 w-4" />
            Delete Course
          </Button>
        </div>
      )}
      
      <Tabs defaultValue="details" className="mt-2">
        <TabsList>
          <TabsTrigger value="details">Course Details</TabsTrigger>
          {!isNewCourse && <TabsTrigger value="lessons">Lessons</TabsTrigger>}
        </TabsList>
        
        <TabsContent value="details" className="mt-6 space-y-6">
          <CourseForm
            initialValues={initialFormValues}
            onSubmit={onSubmit}
            isNewCourse={isNewCourse}
            isSaving={isSaving}
          />
        </TabsContent>
        
        {!isNewCourse && (
          <TabsContent value="lessons" className="mt-6">
            <LessonList 
              courseId={courseId} 
              lessons={lessons} 
              setLessons={setLessons} 
            />
          </TabsContent>
        )}
      </Tabs>
    </div>
  );
};

export default CourseEditorContent;
